export default __webpack_public_path__ + "static/media/CIS-gallery-1-NI-M300T-V.b3268ab8.jpg";